<template>
  <div class="body">
    <div class="container">
      <div class="image"></div>
      <div class="text">Paul Quinn College</div>
    </div>
    <div style="display: flex; flex-direction: column; align-items:center; margin-top: 25px;">
      <div class="" style="width: 1200px; text-align: left;">
        <h1>Get the facts.</h1>
        <hr>
        <p>Paul Quinn College is a private, faith-based, four-year, liberal arts-inspired college that was founded on April 4, 1872, by a group of African Methodist Episcopal Church preachers in Austin, Texas. The school’s original purpose was to educate freed slaves and their offspring. Today, we proudly educate students of all races and socio-economic classes under the banner of our institutional ethos, WE Over Me. Our mission is to provide a quality, faith-based education that addresses the academic, social, and Christian development of students and prepares them to servant leaders and agents of change in the global marketplace.
        </p>
      </div>
      <br>
      <div class="cards">
        <DataCard><Data1 /></DataCard>
        <DataCard><Data2 /></DataCard>
        <DataCard><Data3 /></DataCard>
        <DataCard><Data4 /></DataCard>
        <DataCard><Data5 /></DataCard>
        <DataCard><Data6 /></DataCard>
      </div>
    </div>

  </div>
</template>

<script>
import DataCard from "../components/DataCard.vue";
import Data1 from "../components/Data1.vue";
import Data2 from "../components/Data2.vue";
import Data3 from "../components/Data3.vue";
import Data4 from "../components/Data4.vue";
import Data5 from "../components/Data5.vue";
import Data6 from "../components/Data6.vue";
export default {
  components: {
    DataCard,
    Data1,
    Data2,
    Data3,
    Data4,
    Data5,
    Data6
  },
};
</script>

<style scoped>
/* .container {
    position: relative;
} */
.text {
  position: absolute;
  color: white;
  font-size: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.container {
  height: 700px;
  background-image: url("../assets/imrs.webp");
  background-position: 0% 35%;
  background-attachment: fixed;
  background-size: 100%;
  background-repeat: no-repeat;
}
.cards {
  display: grid;
  grid-template-columns: 400px 400px 400px;
  grid-gap: 45px;
}
.body{
  text-align: center;
}
</style>
